/**
 * 鉴于大部分上传，都是弹框的形式
 * 所以封装一个弹框上传组件
 */

import Vue, { CreateElement, VNode } from 'vue'
import { Modal } from 'ant-design-vue'
import Upload from './Upload'
export default Vue.extend({
  name: 'AheduUploadModal',
  components: {
    MyUpload: Upload,
  },
  data() {
    return {
      // 弹框标题
      title: '',
      // 弹框可见性
      visible: false,
      // 文件列表
      files: [],
      // 上传支持的格式
      exts: [],
      // 上传结果是否有错误
      hasError: false,
      // 是否正在上传
      uploading: false,
    }
  },
  computed: {
    /**
     * 模板地址
     */
    templateUrl(): string {
      return ''
    },
    /**
     * 确定按钮的属性
     * 比如在上传中，就显示loading状态
     * 文件未选中就不可点击
     */
    okButtonProps(): any {
      return {
        props: {
          disabled: this.files.length === 0 || this.hasError,
          loading: this.uploading,
        },
      }
    },
  },
  methods: {
    onOk(): void {
      this.visible = false
    },
    onCancel() {
      this.visible = false
    },
    afterClose() {
      this.files.length = 0
    },
    renderUpload(h: CreateElement) {
      return h('my-upload', {
        ref: 'uploadRef',
        props: {
          exts: this.exts,
          templateUrl: this.templateUrl,
        },
        on: {
          success: this.handleSuccess,
          error: this.handleError,
        },
      })
    },
    handleSuccess() {
      this.visible = false
    },
    handleError(type: string) {
      this.hasError = !!type
    },
    open() {
      this.visible = true
    },
  },
  render(h: CreateElement): VNode {
    return h(
      Modal,
      {
        props: {
          title: this.title,
          visible: this.visible,
          destroyOnClose: true,
          okButtonProps: this.okButtonProps,
          afterClose: this.afterClose,
        },
        on: {
          ok: this.onOk,
          cancel: this.onCancel,
        },
      },
      [this.renderUpload(h)]
    )
  },
})
